
class Helper {
    static numberFormatter = (num) => {
        let number = num ? num.toString().split("").reverse().join("") : "0";
        let formatted = "";
        for( let a = 0; a < number.length; a++ ){
            if( a>0 && a%3 === 0) formatted += ".";
            formatted += number[a];
        }
        return formatted.split("").reverse().join("");
    }

    static numberUnformatter = (formatted) => {
        return  parseInt(formatted.toString().split(".").join(""), 0);
    }
}

export default Helper;


// WEBPACK FOOTER //
// ./src/lib/helper.js